<div class="stripe-form stripe-form-modal">
  <div class="header-modal mb-0">
    <div class="main-title w-100 mt-0 mb-0">
      <h3>Add Payment Method</h3>
    </div>

    <span (click)="cancel()" class="close-dialog">
      <i class="material-icons">close</i>
    </span>
  </div>

  <div class="form-add-new-wrap">
    <p class="card-description">
      Securely save a credit card or US bank account for future payments.
    </p>

    <div *ngIf="verificationUrl" class="verification-banner">
      <p>Your bank account was added but needs verification before it can be used.</p>
      <cmp-button [class]="'primary'" text="Verify Now" (click)="openVerificationUrl()"></cmp-button>
    </div>

    <ng-container *ngIf="!verificationUrl">
      <div *ngIf="clientSecret" class="form-group">
        <ngx-stripe-payment
          [clientSecret]="clientSecret"
          [appearance]="appearance"
          (change)="onChange($event)">
        </ngx-stripe-payment>
      </div>

      <div class="footer-modal">
        <cmp-button [class]="'cancel mr-20'" text="Cancel" (click)="cancel()"></cmp-button>
        <cmp-button
          [disabled]="confirmBtnDisabled || saveBtnLoading || !clientSecret"
          [class]="'primary mr-20'"
          text="Save"
          [loading]="saveBtnLoading"
          (click)="onSubmit()">
        </cmp-button>
      </div>
    </ng-container>
  </div>
</div>
